export const PAGE_BUILDER_DOMAINS = {
  'hubspotpagebuilderqa.eu': {
    hublet: 'eu1',
    env: 'qa'
  },
  'hubspotpagebuilderqa.com': {
    hublet: 'na1',
    env: 'qa'
  },
  'hubspotpagebuilder.eu': {
    hublet: 'eu1',
    env: 'prod'
  },
  'hubspotpagebuilder.ca': {
    hublet: 'na3',
    env: 'prod'
  },
  'hubspotpagebuilder.au': {
    hublet: 'ap1',
    env: 'prod'
  },
  'hubspotpagebuilder.net': {
    hublet: 'na2',
    env: 'prod'
  },
  'hubspotpagebuilder.com': {
    hublet: 'na1',
    env: 'prod'
  }
};
export const HS_SITES_DOMAINS = {
  'hs-sitesqa-eu1.com': {
    hublet: 'eu1',
    env: 'qa'
  },
  'hs-sitesqa.com': {
    hublet: 'na1',
    env: 'qa'
  },
  'hs-sites-eu1.com': {
    hublet: 'eu1',
    env: 'prod'
  },
  'hs-sites-na3.com': {
    hublet: 'na3',
    env: 'prod'
  },
  'hs-sites-ap1.com': {
    hublet: 'ap1',
    env: 'prod'
  },
  'hs-sites-na2.com': {
    hublet: 'na2',
    env: 'prod'
  },
  'hs-sites.com': {
    hublet: 'na1',
    env: 'prod'
  }
};
export const HUBSPOT_COM = 'hubspot.com';
export const HUBSPOTQA_COM = 'hubspotqa.com';
export const HSAPPSTATIC_NET = 'hsappstatic.net';